/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useCallback, useEffect } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import DialogTextField from 'components/dialog/DialogTextField';
import useProjectInfoProvider from 'hooks/useProjectInfoProvider';
import { IStepper4Props } from 'interface/project/projectInfo';
import { getGuideDetail } from 'store/project/projectSlice';
import { useAppDispatch } from 'store';

const stepper4Field: {
  label: string;
  name: keyof IStepper4Props;
}[] = [
  {
    label: '프로젝트 설명 입력',
    name: 'projectDescription',
  },
  {
    label: '프로젝트 참여 동의서',
    name: 'projectAgreement',
  },
  {
    label: '최종 완료 메세지',
    name: 'completeMessage',
  },
  {
    label: '이메일 타이틀',
    name: 'emailTitle',
  },
  {
    label: '이메일 문구',
    name: 'emailBody',
  },
];

function StepperDC4(): JSX.Element {
  const dispatch = useAppDispatch();
  const { dcInputs, onChangeDC } = useProjectInfoProvider();
  const { stepper4, projectId } = dcInputs;
  const handleChange = useCallback(
    (name: string, value: any) => {
      onChangeDC('stepper4', {
        ...stepper4,
        [name]: value,
      });
    },
    [onChangeDC, stepper4],
  );

  useEffect(() => {
    async function fetchData() {
      const response = await dispatch(getGuideDetail({ projectId })).unwrap();
      const { status } = response;
      if (status === 200) {
        onChangeDC('stepper4', {
          projectDescription: response?.data?.des ?? '',
          projectAgreement: response?.data?.agreement ?? '',
          completeMessage: response?.data?.complete ?? '',
          emailTitle: response?.data?.emailTitle ?? '',
          emailBody: response?.data?.emailBody ?? '',
        });
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, projectId]);
  return (
    <Grid item xs={12}>
      <Box sx={{ px: '1.625rem' }}>
        <Grid
          container
          spacing={2}
          sx={{
            mt: '1.5rem',
            width: '100%',
            display: 'flex',
            justifyContent: { xs: 'flex-start', lg: 'center' },
          }}
        >
          <Grid item xs={10}>
            <Typography sx={{ typography: 's13w500' }}>
              {'{user_name}'} 참여자 이름 {'{user_email}'} 참여자 이메일 {'{user_dept}'} 참여자 부서{' '}
              {'{user_comp_name}'} 참여자 회사 이름 {'{user_position}'} 참여자 직급
            </Typography>
            <Typography sx={{ typography: 's13w500', mt: 1 }}>
              볼드와 색상 태그 사용법: 볼드 텍스트는 &lt;b&gt;태그로, 색상 텍스트는 &lt;c=색상&gt;태그로 사용할 수
              있습니다. 중첩도 가능합니다.
            </Typography>
          </Grid>
          {stepper4Field.map(obj => (
            <Grid item xs={10} key={obj.name}>
              <DialogTextField
                label={obj.label}
                labelWidth="100%"
                text={stepper4[obj.name]}
                variant="outlined"
                name={obj.name}
                onChange={e => handleChange(obj.name, e.target.value)}
                multiline
                rows={obj.name === 'emailBody' ? 20 : 4}
                stackDirection={{ xs: 'column', sm: 'column', md: 'column' }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Grid>
  );
}

export default memo(StepperDC4);
